import { ReactNode } from 'react';

export enum AlertType {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'info',
}

export type AlertDTO = {
  type: AlertType | null;
  title: string | null;
  bodyText: string | ReactNode | null;
};

export type AlertState = AlertDTO & {
  isShown: boolean;
  isClosed: boolean;
  isLogoPopUpOpen: boolean;
  isCategoriesPopUpOpen: boolean;
};

export enum AlertDictionaryDiscountBookmark {
  similar = 'similar',
  overlap = 'overlap',
  create = 'create',
  update = 'update',
  delete = 'delete',
  archive = 'archive',
  favorite_add = 'favorite_add',
  favorite_remove = 'favorite_remove',
}
